import { PropsWithChildren } from 'react';
import {
  ChevronDownIcon,
  HbTooltip,
  MenuButton,
  useDisclosure,
  Button,
  forwardRef,
  ButtonProps,
} from '@cdl/heartbeat-react';

type Props = PropsWithChildren<{
  tooltipLabel: string;
}> &
  ButtonProps;

export const MenuButtonWithTooltip = forwardRef<Props, 'button'>(
  ({ children, tooltipLabel, ...rest }, ref) => {
    const { isOpen: tooltipOpen, onOpen, onClose } = useDisclosure();
    return (
      <HbTooltip
        hasArrow
        label={tooltipLabel}
        placement='top'
        isOpen={tooltipOpen}
      >
        <MenuButton
          ref={ref}
          as={Button}
          rightIcon={<ChevronDownIcon />}
          variant='secondary'
          textAlign='left'
          fontWeight='regular'
          {...rest}
          onClick={onClose}
          onMouseEnter={onOpen}
          onMouseLeave={onClose}
        >
          {children}
        </MenuButton>
      </HbTooltip>
    );
  },
);
